import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ToastrModule} from 'ngx-toastr';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AuthModule} from './auth/auth.module';
import {CoreModule} from './core';
import {IncidentModule} from './incident/incident.module';
import {ThemeModule} from './layout/theme';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      preventDuplicates: false
    }),
    CoreModule.forRoot(),
    AuthModule.forRoot(),
    ThemeModule.forRoot(),
    IncidentModule.forRoot()
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: '/'},
    { provide: LOCALE_ID, useValue: navigator.language }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private translate: TranslateService) {
    this.initTranslates();
  }

  initTranslates(): void {
    this.translate.addLangs(['en', 'pl']);
    this.translate.setDefaultLang('en');

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|pl/) ? browserLang : 'pl');
    registerLocaleData(browserLang.match(/pl/) ? localePl : localeEn);
  }

}
